var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineAirpods(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.97 17.11V10.3h-.2c-2.5 0-4.53-2.03-4.53-4.53 0-2.5 2.03-4.53 4.53-4.53h1.89c1.98 0 3.58 1.61 3.58 3.58V17.1a2.625 2.625 0 0 1-2.63 2.65c-1.46 0-2.64-1.18-2.64-2.64zM2.75 5.78c0 1.67 1.36 3.03 3.03 3.03h.95c.41 0 .75.34.75.75v7.56a1.14 1.14 0 1 0 2.28 0V4.84c0-1.15-.93-2.08-2.08-2.08h-1.9v-.01c-1.67 0-3.03 1.36-3.03 3.03z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.09 5.77c0-.94.76-1.69 1.69-1.69.41 0 .75.34.75.75s-.34.75-.75.75a.19.19 0 0 0-.19.19c0 .1.09.2.19.2.41 0 .75.34.75.75s-.34.75-.75.75c-.93 0-1.69-.76-1.69-1.7z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75 17.11V4.83c0-1.98 1.61-3.58 3.58-3.58h1.89c2.5 0 4.53 2.03 4.53 4.53 0 2.5-2.03 4.53-4.53 4.53h-.2v6.81c.01 1.45-1.18 2.63-2.63 2.63-1.46 0-2.64-1.18-2.64-2.64zm1.5-12.28v12.28a1.14 1.14 0 1 0 2.28 0V9.55c0-.41.34-.75.75-.75h.95c1.67 0 3.03-1.36 3.03-3.03 0-1.67-1.36-3.03-3.03-3.03h-1.9v.01c-1.15 0-2.08.93-2.08 2.08z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.47 6.72c0-.41.34-.75.75-.75.11 0 .19-.09.19-.2a.19.19 0 0 0-.19-.19c-.41 0-.75-.34-.75-.75s.34-.75.75-.75a1.694 1.694 0 0 1 0 3.39c-.41 0-.75-.34-.75-.75zM7.75 22v-3c0-.41.34-.75.75-.75s.75.34.75.75v3c0 .41-.34.75-.75.75s-.75-.34-.75-.75zM14.75 22v-3c0-.41.34-.75.75-.75s.75.34.75.75v3c0 .41-.34.75-.75.75s-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineAirpods);
export default __webpack_public_path__ + "static/media/vuesax-outline-airpods.b5777fa87d3f1911c376f20f6f6c4edc.svg";
export { ForwardRef as ReactComponent };